import { createSlice } from "@reduxjs/toolkit";
const initalConst = {
  lenderId: "",
  selectedAccount: {},
  selectedRole: {},
  accountOptions: [],
  roleOptions: [],
  refreshBankingDetails: false,
  isDemoAccount: false,
  manualSelectedAccount: {},
};
const initialState = localStorage.getItem("account")
  ? JSON.parse(localStorage.getItem("account"))
  : initalConst;
export const accountSlice = createSlice({
  name: "account",
  initialState,
  reducers: {
    setLenderID: (state, action) => {
      state.lenderId = action.payload;
      localStorage.setItem("account", JSON.stringify(state));
    },
    setSelectedAccount: (state, action) => {
      state.selectedAccount = action.payload;
      localStorage.setItem("account", JSON.stringify(state));
    },
    setSelectedRole: (state, action) => {
      state.selectedRole = action.payload;
      localStorage.setItem("account", JSON.stringify(state));
    },
    setAccountOptions: (state, action) => {
      state.accountOptions = action.payload;
      localStorage.setItem("account", JSON.stringify(state));
    },
    setRoleOptions: (state, action) => {
      state.roleOptions = action.payload;
      localStorage.setItem("account", JSON.stringify(state));
    },
    resetAccount: (state) => {
      return initalConst;
    },
    setRefreshBankingDetails: (state, action) => {
      state.refreshBankingDetails = action.payload;
    },
    setDemoAccount: (state, action) => {
      state.isDemoAccount = action.payload;
      localStorage.setItem("account", JSON.stringify(state));
    },
    setManualSelectedAccount: (state, action) => {
      state.manualSelectedAccount = action.payload;
    },
  },
});

export const {
  setLenderID,
  setSelectedAccount,
  setAccountOptions,
  setSelectedRole,
  setRoleOptions,
  resetAccount,
  setRefreshBankingDetails,
  setDemoAccount,
  setManualSelectedAccount
} = accountSlice.actions;

export default accountSlice.reducer;
